<template>
  <div
    class="keyboard-adaptation-wrapper"
    :style="{
      ...baseStyle
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'keyboard-adaptation-wrapper',
  props: {
    minDistance: {
      type: Number,
      default: 10,
      required: false
    },
    minElementHeight: {
      type: Number,
      default: 100,
      required: false
    },
    defaultHeight: {
      type: Number,
      default: 150,
      required: false
    }
  },
  data() {
    return {
      baseStyle: {}
    };
  },
  methods: {
    setBaseStyle() {
      const keyboardEl = document.querySelector('.phoenix-keyboard-wrapper');
      this.baseStyle = keyboardEl ? {} : { height: `${this.defaultHeight}px` };
    },
    resizeToFitBesideKeyboard() {
      const MIN_DISTANCE = this.minDistance;
      const MIN_EDITOR_HEIGHT = this.minElementHeight;
      const keyboardEl = document.querySelector('.phoenix-keyboard-wrapper');
      const keyboardRect = keyboardEl?.getBoundingClientRect();
      const editorRect = this.$el.getBoundingClientRect();
      const keyboardVisible = keyboardEl;
      const newHeight = keyboardRect.top - editorRect.top - MIN_DISTANCE;
      if (keyboardVisible) {
        this.$nextTick(() => {
          this.$el.style.height = `${
            newHeight > MIN_EDITOR_HEIGHT ? newHeight : MIN_EDITOR_HEIGHT
          }px`;
        });
      } else {
        this.$nextTick(() => {
          this.$el.style.height = `${this.defaultHeight}px`;
        });
      }
    }
  },
  mounted() {
    this.setBaseStyle();
    this.$root.$on('keyboard-visibility-change', this.resizeToFitBesideKeyboard);
    window.addEventListener('resize', this.resizeToFitBesideKeyboard);
  },
  beforeDestroy() {
    this.$root.$off('keyboard-visibility-change', this.resizeToFitBesideKeyboard);
    window.removeEventListener('resize', this.resizeToFitBesideKeyboard);
  }
};
</script>

<style lang="scss" scoped></style>
